export class PaymentRequestActiveSubscriptionPlanOrderException {}